const plan_de = {
  projectNumber: 'Projekt-Nr.',
  title: 'Meine Pläne',
  search: 'Suche',
  viewArchived: 'Archiviert anzeigen',
  newPlan: 'Neuer Plan',
  noPlans: 'Keine Pläne gefunden',
  filter: {
    allPlans: 'Alle Pläne',
    byType: 'Planungstyp',
  },
  status: {
    draft: 'Entwurf',
    ordered: 'Bestellt',
    confirmed: 'Bestätigt',
    planned: 'Geplant',
    packing: 'Wird gepackt',
    packed: 'Gepackt',
    setup: 'Aufbau',
    setuped: 'Aufgebaut',
    active: 'Event aktiv',
    shipped: 'Versendet',
    retourned: 'Retourniert',
    packdown: 'Abbau',
    complete: 'Abgeschlossen',
  },
  actions: {
    confirm: 'Bestätigen',
  },
  tooltipView: 'Plan ansehen',
  tooltipEdit: 'Plan bearbeiten',
  tooltipDelete: 'Plan löschen',
  delete: 'Löschen',
  deleteConfirm: 'Plan löschen',
  deleteConfirmMessage:
    'Sind Sie sicher, dass Sie diesen Plan löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
  deleteSuccess: 'Plan erfolgreich gelöscht',
  deleteError: 'Plan konnte nicht gelöscht werden',
  editWindow: {
    editableUntil: 'Bearbeitbar bis {date}',
    editableUntilSoon: 'Bearbeitbar bis {date} — noch {days} Tage',
    locked: 'Bearbeitung seit {date} geschlossen',
    eventStarted: 'Veranstaltungsbeginn liegt bereits in der Vergangenheit',
    adminOverride:
      'Bearbeitung für Aussteller seit {date} geschlossen — Admin-Zugriff gilt weiterhin',
    lockedTitle: 'Bearbeitung ist geschlossen',
    lockedMessage:
      'Dieser Plan kann nicht mehr geändert werden. Die Frist war der {date}, {days} Tage vor dem ersten Aufbau- bzw. Versandtag. Bitte wenden Sie sich an Ihren La Concept Ansprechpartner, wenn Sie noch eine Änderung benötigen.',
    saveRejected:
      'Die Bearbeitungsfrist ({date}) ist abgelaufen — Ihre Änderungen wurden nicht gespeichert. Der Plan ist jetzt schreibgeschützt.',
    saveRejectedGeneric: 'Etwas ist schiefgelaufen — Ihre Änderungen wurden nicht gespeichert.',
  },
  form: {
    tradeFairData: 'Messedaten',
    itemsAndSets: 'Artikel und Sets',
    summary: 'Übersicht',
    serviceDescription: 'Kompletter Auf- und Abbauservice durch den Messebauer',
    serviceDescriptionShipping: 'Versandservice durch den Messebauer',

    tradeFire: 'Messe',
    booth: 'Stand',
    billingAddress: 'Rechnungsadresse',

    // planning type
    exhibition_setup: 'Aufbau',
    selectPlanningTypePrompt: 'Wählen Sie einen Planungstyp oben aus, um zu beginnen.',
    shipping: 'Versand',

    // Headers
    planningName: 'Planungsname',
    description: 'Beschreibung',
    planningType: 'Planungstyp',
    exhibitionStartDate: 'Beginn der Messe',
    exhibitionStartTime: 'Startzeit',
    exhibitionStartTimePlaceholder: 'Startzeit (optional)',
    exhibitionEndDate: 'Ende der Messe',
    exhibitionEndTime: 'Endzeit',
    exhibitionEndTimePlaceholder: 'Endzeit (optional)',
    deliveryDay: 'Anlieferdatum',
    deliveryDayTime: 'Anlieferzeit',
    deliveryDayTimePlaceholder: 'Anlieferzeit (optional)',
    collectionDay: 'Abholdatum',
    collectionDayTime: 'Abholzeit',
    collectionDayTimePlaceholder: 'Abholzeit (optional)',
    timeWindowFromPlaceholder: 'Von (optional)',
    timeWindowToPlaceholder: 'Bis (optional)',

    status: 'Status',
    // Document upload
    uploadLabel: 'Upload (Standskizze, Hallenplan, Zugangsskizze, etc.)',
    selectFile: 'Datei auswählen',
    previewPdf: 'PDF Vorschau',
    documentType: 'Dokumententyp',
    documentTypePlaceholder: 'Dokumententyp auswählen',
    documentTypeFirstHint: 'Zuerst einen Typ wählen, dann die Datei auswählen.',
    documentTypes: {
      STANDSKIZZE: 'Standskizze',
      HALLENPLAN: 'Hallenplan / Standplan',
      AUFBAUAUSWEISE: 'Aufbauausweise',
      MESSEINFORMATIONEN: 'Messeinformationen',
      VERSANDETIKETT: 'Versandetikett',
      BEGLEITSCHREIBEN: 'Begleitschreiben',
      DOKUMENT: 'Sonstiges',
    },
    documentNote: 'Notiz',
    removeDocument: 'Entfernen',
    uploadError: 'Dokument konnte nicht hochgeladen werden',
    documentUploadFailed:
      'Ein Dokument konnte nicht hochgeladen werden und bleibt für einen erneuten Versuch gespeichert | {count} Dokumente konnten nicht hochgeladen werden und bleiben für einen erneuten Versuch gespeichert',
    noDocuments: 'Noch keine Dokumente hochgeladen.',

    // Event Address
    eventAddress: 'Veranstaltungsadresse',
    deliveryAddress: 'Lieferadresse',
    placeName: 'Veranstaltungsort',
    department: 'Abteilung',
    streetAddress: 'Straßenadresse',
    postalCode: 'Postleitzahl',
    city: 'Stadt',
    country: 'Land',
    differentPickupAddress: 'Abweichende Abholadresse?',
    pickupAddress: 'Abholadresse',
    pickupPlaceName: 'Ortsname',
    pickupDepartment: 'Abteilung',
    pickupStreetAddress: 'Straßenadresse',
    pickupPostalCode: 'Postleitzahl',
    pickupCity: 'Stadt',
    pickupCountry: 'Land',
    addressLookup: {
      unknownPostalCode:
        'Postleitzahl nicht gefunden — bitte prüfen oder Adresse manuell eingeben.',
      contradictionCity: 'Vorgeschlagene Stadt „{city}" weicht von Ihrer Eingabe ab.',
      contradictionPostal: 'Vorgeschlagene Postleitzahl „{postal}" weicht von Ihrer Eingabe ab.',
    },
    // Shipping (legacy keys kept for compatibility)
    street: 'Straße',
    address1: 'Adresse 1',
    address2: 'Adresse 2',

    // booth type options

    // booth
    boothType: 'Standtyp',
    boothNumber: 'Standnummer',
    boothDimensions: 'Standabmessungen',
    boothArea: 'Standgröße',
    boothDimWidth: 'Breite',
    boothDimHeight: 'Höhe',
    boothDimDepth: 'Tiefe',
    hall: 'Halle',
    customerContactPerson: 'Ansprechpartner vor Ort',
    contactPersonUnavailable: 'Kontakt nicht mehr in work4all vorhanden',
    laConceptContact: 'Ansprechpartner LA CONCEPT',
    customerContactPersonModeExisting: 'Gespeicherten Kontakt auswählen',
    customerContactPersonModeFreeText: 'Anderen Kontakt eingeben',
    customerContactPersonName: 'Name',
    customerContactPersonNamePlaceholder: 'Vollständiger Name',
    customerContactPersonPhone: 'Telefon (optional)',
    customerContactPersonEmail: 'E-Mail (optional)',
    setupDays: 'Aufbautage',
    addSetupDay: 'Tag hinzufügen',
    noSetupDays: 'Noch keine Aufbautage hinzugefügt.',
    dismantlingDays: 'Abbautage',
    addDismantlingDay: 'Tag hinzufügen',
    noDismantlingDays: 'Noch keine Abbautage hinzugefügt.',
    setupDayDate: 'Datum',
    setupDayStartTime: 'Startzeit',
    setupDayEndTime: 'Endzeit',
    otherInformation: 'Weitere Informationen',
    generalInformation: 'Allgemeine Informationen',
    internalOrderNumber: 'Interne Bestellnummer',
    additionalEquipment: 'Zusätzliches Equipment erforderlich',
    additionalEquipmentNote: 'Was wird benötigt?',
    materialWillBeDelivered: 'Material wird angeliefert',
    materialDeliveryDate: 'Lieferdatum',
    materialDeliveryTime: 'Lieferzeit',
    materialDeliveryTimePlaceholder: 'Lieferzeit (optional)',
    materialDeliveryNote: 'Umfang (Palettenanzahl, Anzahl Packstücke, …)',
    yes: 'Ja',
    no: 'Nein',
    boothHandover: 'Standübergabe gewünscht?',
    boothHandoverType: 'Typ',
    boothHandoverTypePersonal: 'Persönliche Übergabe',
    boothHandoverTypeDigital: 'Digitale Übergabe',
    boothHandoverContactPerson: 'Ansprechpartner',
    boothHandoverMobile: 'Handynummer',
    boothHandoverMobileOrEmail: 'Handynummer / E-Mail',
    boothHandoverDigitalType: 'Kontakttyp',
    boothHandoverDigitalTypePlaceholder: 'z.B. WhatsApp, E-Mail',
    boothHandoverDate: 'Übergabedatum',
    boothHandoverTime: 'Übergabezeit',
    boothHandoverTimePlaceholder: 'Uhrzeit wählen',

    // status options
    draft: 'Entwurf',
    ordered: 'Bestellt',

    // buttons
    cancel: 'Abbrechen',
    continue: 'Weiter',
    confirmOrder: 'Bestellung bestaetigen',
    saveChanges: 'Änderungen speichern',
    saveAsDraft: 'Als Entwurf speichern',
    back: 'Zurück',
    stay: 'Bleiben',
    leave: 'Verlassen',
    addItems: 'Artikel hinzufügen',
    // confirm modal
    confirmBack: 'Ungespeicherte Änderungen',
    confirmBackMessage:
      'Sie haben ungespeicherte Änderungen. Möchten Sie diese Seite wirklich verlassen?',
    confirmOrderModalTitle: 'Bestellung bestaetigen',
    confirmOrderModalMessage:
      'Sind Sie bereit, Ihren Plan zu senden und die Bestellung zu bestaetigen?',
    tradeFair: 'Messe',
    // Success/Error messages
    loadError: 'Plan konnte nicht geladen werden',
    createSuccess: 'Plan erfolgreich erstellt',
    updateSuccess: 'Plan erfolgreich aktualisiert',
    createError: 'Plan konnte nicht erstellt werden',
    updateError: 'Plan konnte nicht aktualisiert werden',
    submitSuccess: 'Plan erfolgreich übermittelt',
    submitError: 'Plan konnte nicht übermittelt werden',
    validationError: 'Bitte füllen Sie alle Pflichtfelder aus',
    validationErrorTitle: 'Pflichtfelder fehlen',
    itemsSaveSuccess: 'Artikel erfolgreich gespeichert',
    draftSaveSuccess: 'Als Entwurf gespeichert',
    itemsSaveError: 'Artikel konnten nicht gespeichert werden',
    itemsClearFailed:
      'Ein Artikel konnte nicht entfernt werden und ist weiterhin in der Planung | {count} Artikel konnten nicht entfernt werden und sind weiterhin in der Planung',
    // Errors
    errors: {
      boothHandoverContactInvalid:
        'Bitte geben Sie eine gültige Handynummer oder E-Mail-Adresse ein',
      boothHandoverMobileInvalid: 'Bitte geben Sie eine gültige Handynummer ein',
      cityRequired: 'Stadt ist erforderlich',
      customerContactPersonNameRequired:
        'Bitte geben Sie einen Namen für den Ansprechpartner vor Ort ein',
      customerContactPersonNameTooLong: 'Name darf höchstens 150 Zeichen lang sein',
      customerContactPersonPhoneInvalid: 'Bitte geben Sie eine gültige Telefonnummer ein',
      customerContactPersonEmailInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
      documentTypeRequired: 'Bitte wählen Sie für jedes hochgeladene Dokument einen Dokumententyp',
      countryRequired: 'Land ist erforderlich',
      exhibitionEndDateBeforeStart: 'Das Enddatum darf nicht vor dem Startdatum liegen',
      timeWindowEndBeforeStart: 'Die Endzeit darf nicht vor der Startzeit liegen',
      exhibitionEndDateRequired: 'Enddatum der Messe ist erforderlich',
      exhibitionStartDateRequired: 'Startdatum der Messe ist erforderlich',
      planningNameRequired: 'Planungsname ist erforderlich',
      planningTypeRequired: 'Planungstyp ist erforderlich',
      postalCodeRequired: 'Postleitzahl ist erforderlich',
      streetRequired: 'Straße ist erforderlich',
    },
  },
  step2: {
    itemSets: 'Artikel Sets',
    useThisSet: 'Dieses Set verwenden',
    removeThisSet: 'Dieses Set entfernen',
    addSet: 'Ihre Sets ansehen',
    hideSets: 'Sets ausblenden',
    groupView: 'Gruppenansicht',
    listView: 'Listenansicht',
    search: 'Suche',
    filter: 'Filter',
    filterTitle: 'Artikel filtern',
    category: 'Kategorie',
    selectCategory: 'Kategorie auswählen',
    apply: 'Anwenden',
    cancel: 'Abbrechen',
    selectedItems: 'Ausgewählte Artikel',
    removeItem: 'Artikel entfernen',
    quantity: 'Menge',
    quantityOf: 'Menge von {name}',
    increaseQuantity: 'Menge von {name} erhöhen',
    decreaseQuantity: 'Menge von {name} verringern',
    rentItem: 'Mietartikel',
    ownItem: 'Eigener Artikel',
    showAll: 'Alle anzeigen',
    stillAvailable: '{count}x verfügbar',
    showRental: 'Mietartikel anzeigen',
    onlyAvailable: 'Nur verfügbare Artikel',
    // Loading messages, without trailing dots — the loader animates them.
    availabilityLoading: {
      checking: 'Artikelverfügbarkeit wird geprüft',
      stock: 'Lagerbestände werden ausgelesen',
      exhibition: 'Verfügbarkeit für die Ausstellung wird geprüft',
      compiling: 'Verfügbare Artikel werden zusammengestellt',
    },
    widthDepthHeight: 'Breite x Tiefe x Höhe',
    weight: 'Gewicht',
    name: 'Name',
    itemInfo: 'Artikelinfo',
    itemType: 'Artikeltyp',
    availability: 'Verfügbarkeit',
    price: 'Preis',
  },
  step3: {
    summaryDescription: 'Überprüfen Sie Ihre Plandetails vor dem Absenden.',
    tracking: 'Sendungsverfolgung',
    outboundTracking: 'Hinversand',
    returnTracking: 'Rückversand',
    trackShipment: 'Sendung verfolgen',
    visualizations: 'Visualisierungen',
    boothPhotos: 'Standübergabe',
    boothPhotosHint: 'Fotos des Messebauers vom aufgebauten Stand.',
    shippingPhotos: 'Versandfotos',
    shippingPhotosHint: 'Fotos des Messebauers von der Ware beim Versand.',
    openFile: 'Datei öffnen',
    uploads: 'Uploads (Standskizze, Hallenplan, Zugangsskizze, etc.)',
    orderSummary: 'Bestellübersicht',
    name: 'Name',
    quantity: 'Menge',
    noItemsSelected: 'Keine Artikel ausgewählt',
    uncategorized: 'Ohne Kategorie',
    status: 'Status',
    requested: 'Angefordert',
    confirmed: 'Bestätigt',
    selected: 'Ausgewählt',
    checking: 'Prüfen...',
    available: 'Verfügbar',
    unavailable: 'Nicht verfügbar',
    itemUnavailable: '{available} verfügbar, {requested} angefordert',
    unavailableWarning:
      'Einige der ausgewählten Artikel sind für die ausgewählten Daten nicht verfügbar. Wir kommen gerne diesbezüglich zur weiteren Absprache auf Sie zu.',
  },
}

export default plan_de
